
export const vgongBlocFirstTemplate = (videoUrl, imgSrc, videoTitle, labelText) =>`
<div class="first-video card v-gong">
    <a class="thumb-cont" href="${videoUrl}">
        <picture>
            <img loading="lazy" src="${imgSrc}" alt="${videoTitle}" />
        </picture>
        <svg class="icon play-circle"><use xlink:href="#icon-play_simp"></use></svg>
        <div class="item-info">        
            <div class="duration-label"><svg class="icon"><use xlink:href="#icon-play_simp"></use></svg><span>${labelText}</span></div>
            <h3 class="title">${videoTitle}</h3>
        </div>
    </a>
</div>
`